import React, { Component } from 'react';
import {
    Container,
    Row,
} from 'reactstrap';
import { HomeButtonCat } from './HomeButtonCat'
import iconaBlank from '../../img/icona blank.png'
/**
 * Used for the Listino Prezzi section. 
 */
export class Catalogo2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            //Visibility of Level 2
            showLivelli3: true,
            //Stores the items for Level 3
            Livelli3: [],
            //Selected item in Level 3
            livelli3IndexSelected: 0,
            //Description Level 3
            deslv3: "",
            //Location in page 
            locInPage: "Livelli3"
        };

    }

    /**
     * Renders the page
     */
    render() {

        //Creates the level 3 Buttons
        const livelli3Buttons = (
            <Row style={{ width: '100%', margin: '0px' }}>
                {this.props.livelli3.map(value => {
                    let bgColor = '';
                    //Sets the background color of each button
                    if (this.props.livelli3Id !== 0 & value.livelli3Id === this.props.livelli3Id) {
                        bgColor = '#57d2ff';
                    }
                    else {
                        bgColor = 'transparent';
                    }

                    return <HomeButtonCat buttonBackground={bgColor}
                        history={this.props.history}
                        clicked={() => this.props.handleLivelli3ButtonClick(value.livelli3Id, value.deslv3)}
                        image={iconaBlank} //TODO: Create function to determine appropriate image
                        key={value.livelli3Id}
                        index={value.livelli3Id}
                        name={value.deslv3}
                        needsText={true} //will remove once there is images
                        off="true"
                        classes={"col-md-3 col-6"} />
                })}
            </Row>
        );

        return (
            <Container fluid>
                {this.props.showLivelli3 ? livelli3Buttons : null}
            </Container>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Catalogo/Catalogo2.js